const METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE",
};

const ENDPOINTS = {
  NAV: {
    LOGOUT: {
      url: "iam/v1/signout",
      method: METHODS.DELETE,
    },
  },
  LOGIN: {
    REQUEST_OTP: {
      url: "iam/v1/signin/primary/otp?role=transporter",
      method: METHODS.POST,
    },
    REQUEST_EMAIL_OTP: {
      url: "iam/v1/signin/primary/emailotp?role=transporter",
      method: METHODS.POST,
    },
    VALIDATE_OTP: {
      url: "iam/v1/signin/primary/otp?role=transporter",
      method: METHODS.PUT,
    },
    GET_TRANSPORTER_PROFILE: {
      url: "wheelz/api/core/transporters/<transporter_id>/profile",
      method: METHODS.GET,
    },
  },
  DASHBOARD: {
    TRUCKS: {
      GET_DETAIL: {
        url: "wheelz/api/features/vehicle-check",
        method: METHODS.POST,
      },
      GET_SAVED: {
        url: "wheelz/api/features/get-saved-vehicles",
        method: METHODS.GET,
      },
      SAVE_TRUCK: {
        url: "wheelz/api/features/save-vehicle",
        method: METHODS.POST,
      },
    },
    TRACKING: {
      GET_TRACKING: {
        url: "wheelz/api/fastag/fast-tag-location",
        method: METHODS.POST,
      },
      GET_ACTIVE_TRACKING: {
        url: "wheelz/api/fastag/active-requests",
        method: METHODS.GET,
      },
      STOP_TRACKING: {
        url: "wheelz/api/fastag/stop-tracking",
        method: METHODS.PATCH,
      },
      CREATE_REQUEST: {
        url: "wheelz/api/fastag/create-request",
        method: METHODS.POST,
      },
    },
  },
};
const urlWithPrefix = (url) => process.env.REACT_APP_WHEELZ_API_PREFIX + url;

export { ENDPOINTS, METHODS, urlWithPrefix };
